import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import "./styles/layout.css";

if (import.meta.env.DEV) {
  import("./lib/searchSelfCheck").then(({ runSmartSearchSelfCheck }) => {
    if (!runSmartSearchSelfCheck()) {
      console.warn("PULS smart search self-check failed");
    }
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
